import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { AccountDetailsView, ColumnFields } from 'cargo-chief-commons';
import { UtilService } from '@service/util/util.service';
import { COPY_TO_CLIPBOARD_MSGS } from '@domain/constants/app-variables';

@Component({
	selector: 'app-column-details',
	templateUrl: './column-details.component.html',
	styleUrls: ['./column-details.component.scss'],
	providers: [CurrencyPipe],
})
export class ColumnDetailsComponent implements OnInit {
	@Input() dataSource: Array<Array<ColumnFields>>;
	@Input() accountDetails: AccountDetailsView = null;
	@Output() updatedPlan: EventEmitter<any> = new EventEmitter();
	COPY_TO_CLIPBOARD_MSGS = COPY_TO_CLIPBOARD_MSGS;

	constructor(public utilService: UtilService) {}

	ngOnInit() {}
}
